import React, { useState } from 'react';
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import { Icon } from '@iconify/react';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TableChartIcon from '@mui/icons-material/TableChart';
import SelectOptionLayout, { SideItem } from '../../../../../layouts/components/SelectOptionLayout';
import ListaDescuentoPaq from '../../../usuarios/usuarios/section-8/ListaDescuentoPaq';
import ListaEnvio from '../../../paquetes/ListaEnvio';
import ListaEnvioUsuarioLicenciatario from '../../../paquetes/ListaEnvioUsuarioLicenciatario';

export default function DialogEditUser({ dataUser }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      {/* <Button variant="contained" color="info" onClick={() => setOpenDialog(true)}>
        Abrir dialogo
      </Button> */}
      <IconButton size="small" onClick={() => setOpenDialog(true)}>
        <Icon icon="eva:more-vertical-fill" />
      </IconButton>
      <DialogBody open={openDialog} onClose={setOpenDialog} dataUser={dataUser} />
    </>
  );
}

function DialogBody({ open, onClose, dataUser }) {
  const [section, setSection] = useState(1);

  const handleClose = () => {
    onClose(false);
  };

  const side = (
    <>
      {/* <SideItem text="Abonos, cargos y wallet" section={1} action={setSection} icon={<AccountBalanceWalletIcon />} /> */}
      <SideItem text="Envíos" section={1} action={setSection} icon={<TableChartIcon />} />
      {['cliente-corporativo', 'almighty'].includes(dataUser.role) && (
        <>
          <SideItem text="Descuento" section={2} action={setSection} icon={<AccountBalanceWalletIcon />} />
        </>
      )}
    </>
  );

  const body = (
    <>
      {section === 1 && (
        <Grid item xs={12}>
          <Card sx={{ padding: '15px' }}>
            <ListaEnvioUsuarioLicenciatario userId={dataUser.id} />
          </Card>
        </Grid>
      )}
      {section === 2 && (
        <Grid item xs={12}>
          <Card sx={{ padding: '15px' }}>
            <ListaDescuentoPaq dataUser={dataUser} />
          </Card>
        </Grid>
      )}
    </>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle> */}
      <DialogContent>
        <SelectOptionLayout sidebar={side} body={body} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
